// extracted by mini-css-extract-plugin
export var cancelButton = "_nv-5";
export var content = "_nv-3";
export var createButton = "_nv-6";
export var drawerContainer = "_nv-0";
export var footer = "_nv-2";
export var header = "_nv-1";
export var orderFormColumn = "_nv-4";